import { useMsal } from "@azure/msal-react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Button,
  Grid,
  List,
  ListItemButton,
  ListItemText,
  Menu,
  Typography,
} from "@mui/material";
import useUserTenants from "auth/hooks/useUserTenants";
import usePopup from "common/hooks/usePopup";
import { useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";

const EnvironmentsPopup = () => {
  const userTenants = useUserTenants();
  const { anchorEl, handleClose, handleOpen, open } = usePopup();
  const { instance } = useMsal();
  const location = useLocation();
  const history = useHistory();

  const currentAccountTenant =
    instance.getActiveAccount()?.idTokenClaims?.rpaf_tenant;

  const handleClickTenantId = useCallback(
    (newTenantId: string | null) => {
      if (!newTenantId) return;

      const queryParams = new URLSearchParams(location.search);
      queryParams.set("tid", newTenantId);

      const path = history.createHref({
        pathname: location.pathname,
        search: queryParams.toString(),
      });

      window.location.assign(path);
    },
    [location.search, location.pathname, history]
  );

  return (
    <>
      <Grid container direction="column" alignItems="flex-start" spacing={0}>
        <Grid item>
          <Button
            color="primary"
            endIcon={<KeyboardArrowDownIcon />}
            size="small"
            onClick={handleOpen}
          >
            Environment
          </Button>
        </Grid>
        <Grid item>
          <Typography color={"primary"} fontSize={11} paddingLeft={"0.25rem"}>
            {userTenants
              .find((x) => x.id === currentAccountTenant)
              ?.name?.toUpperCase()}
          </Typography>
        </Grid>
      </Grid>
      <Menu
        PaperProps={{ sx: { minWidth: 300 } }}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={open}
        onClose={handleClose}
      >
        <List dense>
          {userTenants.map((item) => (
            <ListItemButton
              key={item.id}
              divider
              onClick={() => handleClickTenantId(item.id)}
            >
              <ListItemText
                primary={item.name}
                secondary={item.id?.split("-").at(-1)}
                secondaryTypographyProps={{ fontSize: 12 }}
              />
              <CheckCircleIcon
                color={
                  currentAccountTenant === item.id ? "success" : "disabled"
                }
              />
            </ListItemButton>
          ))}
        </List>
      </Menu>
    </>
  );
};

export default EnvironmentsPopup;
